import { useRouter, useNuxtApp, useRuntimeConfig, useRoute } from '#imports';
import { createGtm, useGtm } from '@gtm-support/vue-gtm';

export function useAnalytics() {
    const { vueApp } = useNuxtApp();
    const { public: config } = useRuntimeConfig();

    const initGtm = (overrideConfig = {}) => {
        const gtmConfig = config?.gtm ?? overrideConfig;

        if (!vueApp.config.globalProperties.$gtm && gtmConfig.id) {
            vueApp.use(createGtm({
                ...gtmConfig,
                vueRouter: useRouter(),
            }));
            if (import.meta.client) {
                const { name: screenName, path } = useRoute();
                vueApp.config.globalProperties.$gtm.trackView(screenName, path);
            }
        }
    };

    const gtm = () => {
        if (vueApp.config.globalProperties.$gtm) {
            return useGtm();
        }

        const notConfigured = () => {
            if (process.env.NODE_ENV === 'development' && process.env.GTM_DEBUG) {
                console.warn('Gtm not loaded');
            }
        };

        return {
            trackView: notConfigured,
            trackEvent: notConfigured,
            push: notConfigured,
        };
    };

    return {
        initGtm,
        gtm,
    };
}
